/*
NAME: DashBoardDev
DESC: Tela de DashBoard para desenvolvedores, com acesso a todas as funcionalidades do sistema, 

props:
- 
- - - - Default
- style: Object, style object to overwrite this component style
NOTES:

*/



import React, { useEffect, useState } from 'react';
import BasicCard from '../basic/BasicCard';
import ProjectChart from '../basic/ProjectChart';
import InfoCard from '../basic/InfoCard';
import InfoContainer from '../basic/InfoContainer';
import RowContainer from '../basic/RowContainer';
import RowContainerItem from '../basic/RowContainerItem';
import EquipmentsDashboardList from '../specific/EquipmentsDashboardList';
import EquipmentsMap from '../specific/EquipmentsMap';
import strings from '../../values/strings/strings';
import values from '../../values/values'
import colors from '../../values/colors'
import { Stack, Divider, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import EquipamentGetData from '../../usecases/EquipamentGetData';
import UserGetData from '../../usecases/UserGetData';
import WorksGetData from '../../usecases/WorksGetData';
import UserDashBoardList from '../specific/UserDashBoardList';
import { useHistory } from 'react-router';
import ButtonEdit from '../basic/ButtonEdit';
import WorksList from '../specific/WorksList';
import CacheLoadCredentials from '../../usecases/CacheLoadCredentials';
import EquipamentChartConnected from '../specific/EquipamentChartConnected';
import EquipamentChartRegistred from '../specific/EquipamentChartRegistred';
import UsersChart from '../specific/UsersChart';
import WorksChartPeriod from '../specific/WorksChartPeriod';
import WorksChartPeriodSinc from '../specific/WorksChartPeriodSinc';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import ProjectChartEquip from '../basic/ProjectChartEquip';
import Refresh from '../basic/Refresh';
import { yellow } from '@mui/material/colors';
import AuthBuildHeaderUserObject from '../../usecases/AuthBuildHeaderUserObject';
import APIManager from '../../connection/APIManager';
import WorksGetMonitoring from '../../usecases/WorksGetMonitoring'

function DashBoardDev({ }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [equipamentos, setequipamentos] = useState([])
    const [loading, setloading] = useState(null)
    const [trabalhos, settrabalhos] = useState([])
    const [usuarios, setusuarios] = useState([])
    const [usuarioLogado, setUsuarioLogado] = useState(null)
    const [equipamentosConectados, setEquipamentosConectados] = useState([])
    const [equipamentosBloqueados, setequipamentosBloqueados] = useState([]);
    const [equipamentosRegistrados, setequipamentosRegistrados] = useState([]);
    const [trabalhosIniciados, setTrabalhosIniciados] = useState(0)
    const [usuariosConectados, setUsuariosConectados] = useState(0)
    const [novosUsuarios, setNovosUsuarios] = useState(0)
    const [trabalhosPendentes, setTrabalhosPendentes] = useState(0)
    const [sincronismoLastMonth, setsincronismoLastMonth] = useState(0)
    const [saframaxAjuda, setsaframaxAjuda] = useState(0)
    const [totalTrabalhos, settotalTrabalhos] = useState(0)
    const [position, setPosition] = useState(null)

    const getUsuarioLogado = async () => {
        let user = await CacheLoadCredentials()
        setUsuarioLogado(user)
    }
    useEffect(() => {
        getLocalizacao()
        getEquipamentos()
        getUsers()
        getTrabalhos()
        getUsuarioLogado()
    }, [])

    useEffect(() => {
        let trabalhostotal = trabalhos.length
        let newtrabalhos = 0
        let pendentes = 0

        trabalhos.forEach((item, index) => {
            if (item.trabalho_status === 'INICIADO')
                newtrabalhos++
            if (item.trabalho_status === 'PARADO')
                pendentes++
        })
        setTrabalhosPendentes(pendentes)
        setTrabalhosIniciados(newtrabalhos)
        settotalTrabalhos(trabalhostotal)
    }, [trabalhos])

    useEffect(() => {
        let qtdusuarios = usuarios;
        let data = new Date();
        let lastDate = new Date();
        lastDate.setDate(data.getDate() - 30);
        let novosusuarios = 0;
      
      
        usuarios.forEach(item => {
          const tableData = new Date(item.data_cad_server); 
          if (tableData >= lastDate && tableData <= data) {
            novosusuarios++;
          }
        });
      
      
        setUsuariosConectados(qtdusuarios.length);
        setNovosUsuarios(novosusuarios);
      }, [usuarios]);
      
    useEffect(() => {

        let qtdequipamentos = equipamentos;
        setEquipamentosConectados(qtdequipamentos.length)
    }, [equipamentos])

    //Chamadas de equipametos, usuarios e trabalhos  
      useEffect(() => {
        let bloqueados = 0
        let conectados = 0
   
        equipamentos.forEach((item, index) => {
          
            if(item.autorizado !== 1 ) bloqueados++
            if (item.status === 'CONECTADO') conectados++    
          setequipamentosBloqueados(bloqueados)
          setequipamentosRegistrados(equipamentos.length)
        })
    }, [equipamentos])

    const history = useHistory();

    useEffect(() => {
        //#TODO - Conferir se está certo essa função - Seu objetivo é retornar a quantidade de sincronismo do mes
        let date = new Date()
        let lastDate = new Date()
        lastDate.setDate(date.getDate()  - 30)


        let sincronismo = 0
        let trabalhospendentes = 0;
        trabalhos.forEach(item => {
            const tableData = new Date(item.data_inicio)
            if (item.trabalho_status !== 'ERROR' && tableData >= lastDate) {
                sincronismo++
            }
            if (item.sincronismo.sincronismo_status !== 'CONCLUIDO') {
                trabalhospendentes++
            }
        })
        // setTrabalhosPendentes(trabalhospendentes)
        setsincronismoLastMonth(sincronismo)
    }, [trabalhos])


    const getSaframaxAjuda = () => {
        //função responsavel receber a quantidade de acesso ao saframax ajuda
    }
        
    {/*Chamadas de equipametos, usuarios e trabalhos  */ }
    const getEquipamentos = () => {

        setloading(true)
        EquipamentGetData().then(items => {
            setequipamentos(items)
        }).catch(err => {
            console.error('Erro ao contar a quantidade de equipamentos ' + err)
        }).finally(() => {
            setloading(false)
        })
    }

    const getUsers = () => {

        setloading(true)
        UserGetData().then(items => {
            setusuarios(items)
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            setloading(false)
        })
    }

    const getLocalizacao = () => {
        return new Promise(async (resolve, reject) => {
            setloading(true)
            let obj = await AuthBuildHeaderUserObject().catch(e => { return null })
            if (!obj) reject()

            let headers = {
                ...obj
            }

            APIManager.send("/trabalho/basic/equipamentos", "GET", headers)
            .then(res => {
                return res.json()
            }).then(json => {
                resolve(json)
                setPosition(json)
            }).catch(e => {
                reject(e)
            }).finally(() => {
                setloading(false)
            })
        })
    }

    const getTrabalhos = () => {
        setloading(true)
        WorksGetMonitoring().then(items => {
            settrabalhos(items)
        }).catch(err => {
            console.error('Erro ao contar a quantidade de trabalhos ' + err)
        }).finally(() => {
            setloading(false)
        })
    }

    {/*Fim das chamadas de equipamentos, usuarios e trabalhos  */ }
    function editChart() {
        alert('Editar gráfico')
    }

    return (
        <div>

            <RowContainer> 
                <RowContainerItem >
                    <InfoCard flex title={strings.getString('unity_synchronisms_lastMonth')} value={sincronismoLastMonth} />
                </RowContainerItem>
                <RowContainerItem >
                    <InfoCard flex title={strings.getString('works_total_monitoring')} value={totalTrabalhos} />
                </RowContainerItem>
                <RowContainerItem >
                    <InfoCard flex title={strings.getString('unity_work_pendent_title')} value={trabalhosPendentes} />
                </RowContainerItem>
                <RowContainerItem >
                    <InfoCard flex title={'Trabalhos iniciados'} value={trabalhosIniciados} />
                </RowContainerItem >
                <RowContainerItem >
                    <InfoCard flex title={strings.getString('equips_connecteds')} value={equipamentosConectados} />
                </RowContainerItem>
            </RowContainer>

            <RowContainer style={{ display: 'flex', width: '100%', flexDirection: isMobile ? 'column' : 'row' }}>
                <RowContainerItem style={{display: 'flex' , flex: 1, flexDirection:'column', width: '55%'}}>
                    <EquipmentsMap trabalhos={position} height={650} /> 
                    <Divider oritentation="horizontal" flexItem style={{margin: values.margin[0]}} />              
                    <BasicCard >
                    <AgricultureIcon style={{ marginRight: '8px' }} sx={{fontSize:35 , color: yellow['A700']}} />
                        <EquipmentsDashboardList 
                            usuarioLogado={usuarioLogado} 
                            RowsPerPage={15} 
                            items={equipamentos} 
                            usuario={usuarios} 
                            refresh={getEquipamentos} 
                            loading={loading} />
                        <Refresh onClick={getEquipamentos} />
                    </BasicCard>
                </RowContainerItem>
                <RowContainerItem style={{display: 'flex' , flex: 1, flexDirection:'column', width: '45%'}}>
                    <div style={{
                        display: 'flex',
                        marginBottom: values.margin[1],
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: values.margin[1],
                        width: '100%',
                    }}>
                        <InfoCard flex title={strings.getString('users_connecteds')} value={usuariosConectados} />
                        <InfoCard flex title={strings.getString('users_new_users')} value={novosUsuarios} />
                    </div>
                    <Divider oritentation="vertical" flexItem style={{margin: values.margin[1]}} />
    
                    <BasicCard >
                        <UserDashBoardList  
                            usuarioLogado={usuarioLogado} 
                            rowsPerPage={25}    
                            items={usuarios} 
                            refresh={getUsers} 
                            loading={loading} />
                        <Refresh onClick={getUsers} />
                    </BasicCard>
                </RowContainerItem>
            </RowContainer>


            {/*
            /// Implementações precisam de revisão, verificar melhor forma de apresentação  ///
            RowContainer spacing={4}> 
                <RowContainerItem>
                <BasicCard style={{ flex:1, textAlign: 'left', color:"#F8C102", fontWeight: 'bold'}}>
                <ProjectChartEquip  
                    items = {{equipamentosBloqueados , equipamentosConectados, equipamentosRegistrados}}
                    total = {equipamentos.length + equipamentosBloqueados}/>
                </BasicCard>
                </RowContainerItem>
            </RowContainer>*/}

            <RowContainer spacing={4} >
                <RowContainerItem minWidth={800}>     {/*VER MELHOR SOLUÇÃO */}
                    
                </RowContainerItem>
            </RowContainer>
                {/* 
            <RowContainer>
                  /// Implementações precisam de revisão, verificar melhor forma de apresentação  ///
                <RowContainerItem>
                    <UsersChart items={usuarios} />
                </RowContainerItem>
                </RowContainerItem>
            </RowContainer>
                
                /// Implementações precisam de revisão, verificar melhor forma de apresentação  ///
            <RowContainerItem>
                <WorksChartPeriodSinc items={trabalhos} />
                <WorksChartPeriod items={trabalhos} />
            </RowContainerItem>
            <RowContainerItem>
            */}
        </div>
    );
}

export default DashBoardDev;

/* ALTERAÇÃO NA RESPONSIVIDADE 
 <Grid item xs={12} md={6} height={100}>
    <UsersChart items={usuarios} />
</Grid>
            <RowContainer>         
                <RowContainerItem >                                            
                    <EquipmentsMap />                                                    
                </RowContainerItem>  
                <RowContainerItem style={{maxWidth:500,minWidth:300, width:'100%'}}>     
                <BasicCard style={{marginTop: values.margin[2], flex: 1}} >   
                <EquipmentsList usuarioLogado={usuarioLogado} RowsPerPage={6}  items={equipamentos} refresh={getEquipamentos} loading={loading} />                                                   
            </BasicCard>
        </RowContainerItem>  
       
       <RowContainerItem >
          <EquipamentChartConnected items={equipamentos} /> 
          <EquipamentChartRegistred items={equipamentos} />
        </RowContainerItem>
    </RowContainer>
    
    <RowContainer >  
        <RowContainerItem style={{maxWidth:600,minWidth:200, width:'100%',}}>   {/*IMPROVE - Solução provisória adicionada nos RowContainerItem 
            <BasicCard style={{marginTop: values.margin[2],flex:1}} >
                <UsersList  usuarioLogado={usuarioLogado} RowsPerPage={10}  items={usuarios} refresh={getUsers} loading={loading} />
            </BasicCard>
        </RowContainerItem>
        <RowContainerItem>
             <UsersChart items={usuarios} />
         </RowContainerItem>              
    </RowContainer>
     {
     <RowContainer spacing ={4}>
<RowContainerItem style={{maxWidth:500,minWidth:300, width:'100%'}}>  
    <BasicCard style={{marginTop: values.margin[2]}} >   
        <WorksList usuarioLogado={usuarioLogado} 
        title={strings.getString('default_works_list')} 
        RowsPerPage={10} items={trabalhos} 
        refresh={getTrabalhos} 
        loading={loading} />
    </BasicCard>
</RowContainerItem> {/*ITEM AQUI 

<RowContainerItem style={{flexDirection: "column", flex:1}}>

<WorksChartPeriod items={trabalhos}/> 
<WorksChartPeriodSinc items ={trabalhos}/> 
       

</RowContainerItem>
</RowContainer>
    
</div>
);
}

export default DashBoardDev;




*/